import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingWA from "./FloatingWA";
import BackToTop from "./BackToTop";
import WelcomePopup from "./WelcomePopup";
import { prefetchPublicData } from "@/lib/publicCache";
import "@/sas-home.css";

const SiteLayout = () => {
  useEffect(() => {
    prefetchPublicData();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white sas">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingWA />
      <BackToTop />
      <WelcomePopup />
    </div>
  );
};

export default SiteLayout;
